/*
 * Copyright (c) Fing. All rights reserved.
 */

export function scoreDecimals(n, d) {
    if ((typeof n !== 'number') || (typeof d !== 'number'))
        return '';
    n = parseFloat(n) || 0;
    return n.toFixed(d);
}

export function roundPercentile(percentile, factor) {
    let quotient = Math.floor(percentile/factor);
    let remainder = percentile % factor;

    return Math.round(Math.max((quotient * factor) +
        (remainder >= factor / 2.0 ? factor : 0), factor));
}

export function toCompactAmount(num) {
    if (num > 1000) {
        return Math.round(num / 1000) + "k+"
    } else if (num > 100) {
        return Math.round(num / 100) * 100 + "+"
    } else if (num > 10) {
        return Math.round(num / 10) * 10 + "+"
    } else {
        return num
    }
}


export function formatIspTrend(num) {
    if (num>=0.15) return "fa-fw fa-angle-double-up text-dark";
    else if (num>=0.03) return "fa-fw fa-angle-up text-dark";
    else if (num<=-0.15) return "fa-fw fa-angle-double-down text-dark";
    else if (num<=-0.03) return "fa-fw fa-angle-down text-dark";
    else  return "fa-fw fa-angle-right text-dark";
}

export function formatIspTrendTextKey(num) {
    if (num>=0.15) return "isp_trend_up";
    else if (num>=0.03) return "isp_trend_up";
    else if (num<=-0.15) return "isp_trend_down";
    else if (num<=-0.03) return "isp_trend_down";
    else  return "isp_trend_stable";
}
